import { createTermTagManager } from '../../utils/createTermTagManager';

export const hasElectricityTagManager = createTermTagManager({
  jsonQueryKey: 'has_electricity',
  label: 'Есть электричество',
  id: 'hasElectricity',
});
